import React, { useContext } from "react";
import { ModalConfirmationStyled } from "./ModalConfirmationStyled";
import { useSelector } from "react-redux";
import { getModalData } from "../../slice/selectors";
import Typography from "../../../../UI/Typography";
import { TYPOGRAPHY_TYPE } from "../../../../entities/Typography";
import Flex from "../../../../UI/Flex";
import { JUSTIFY_CONTENT } from "../../../../entities/Flex";
import Button from "../../../../UI/Button";
import { ButtonStyledWidth } from "../../../../entities/Button";
import { TranslationContextInterface } from "../../../../entities/Language";
import { TranslationContext } from "../../../../context/TranslationContext";
import { getValueForKey } from "../../../../context/translationsUtils";
import { useAppDispatch } from "../../../../store/store";
import { onCloseModal } from "../../slice/ModalSlice";
import { createMixFromPlatform } from "../../../Checkout/slice/actions";
import { TEST_ID } from "../../../../shared/testid";

const ModalConfirmation: React.FC = () => {
  const { translations }: TranslationContextInterface =
    useContext(TranslationContext);

  const dispatch = useAppDispatch();

  const { content } = useSelector(getModalData);
  const { description = "", tenantName = "", createMixPayload = {} } = content;

  return (
    <ModalConfirmationStyled>
      <div className="modal-confirmation__row">
        <Typography type={TYPOGRAPHY_TYPE.REGULAR}>{description}</Typography>
        <Typography type={TYPOGRAPHY_TYPE.REGULAR}>-</Typography>
        <Typography type={TYPOGRAPHY_TYPE.BOLD}>{tenantName}</Typography>
      </div>

      <div className="modal-confirmation__buttons">
        <Flex
          styles={{
            justify: JUSTIFY_CONTENT.SPACE_BETWEEN,
          }}
        >
          <Button
            name={getValueForKey(
              translations,
              "nav_bar.nav_card_cancel_button",
            )}
            styles={{
              width: ButtonStyledWidth.FULL,
              $margin: "0 20px 0 0",
            }}
            testid={TEST_ID.CREATE_MIX.CONFIRMATION_CANCEL_BUTTON}
            className="transparent"
            onClick={() => dispatch(onCloseModal())}
          />
          <Button
            styles={{
              width: ButtonStyledWidth.FULL,
            }}
            name={getValueForKey(
              translations,
              "nav_bar.nav_card_confirm_button",
            )}
            testid={TEST_ID.CREATE_MIX.CONFIRMATION_CONFIRM_BUTTON}
            onClick={() => dispatch(createMixFromPlatform(createMixPayload))}
          />
        </Flex>
      </div>
    </ModalConfirmationStyled>
  );
};
export default ModalConfirmation;
